export function buildAuthHeaders() {
  const token = localStorage.getItem('accessToken');
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  if (token !== null) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const impersonatedUserId = localStorage.getItem('impersonatedUserId');
  if (impersonatedUserId) {
    headers['X-Impersonated-User'] = impersonatedUserId;
  }

  return headers;
}
